"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "agliana": {
    "1c635853": [{
      "hkey": "a6d07c89",
      "slug": "agliana",
      "name": "Agliana",
      "primary": true,
      "skipSearch": false
    }],
    "berlicche": [{
      "hkey": "a6d07c89",
      "slug": "agliana",
      "name": "Agliana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fc9deb40": [{
      "hkey": "a6d07c89",
      "slug": "agliana",
      "name": "Agliana",
      "primary": true,
      "skipSearch": false
    }],
    "il-mulo": [{
      "hkey": "a6d07c89",
      "slug": "agliana",
      "name": "Agliana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f2b121e3": [{
      "hkey": "916b156d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "la-catena": [{
      "hkey": "916b156d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "agliana"
    }],
    "7fc5868c": [{
      "hkey": "a6d07c89",
      "slug": "agliana",
      "name": "Agliana",
      "primary": true,
      "skipSearch": false
    }],
    "la-torre": [{
      "hkey": "a6d07c89",
      "slug": "agliana",
      "name": "Agliana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "21a70a50": [{
      "hkey": "916b156d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-alla-trave": [{
      "hkey": "916b156d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "agliana"
    }],
    "e5e584ae": [{
      "hkey": "a6d07c89",
      "slug": "agliana",
      "name": "Agliana",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-di-ferro": [{
      "hkey": "a6d07c89",
      "slug": "agliana",
      "name": "Agliana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e4c55e81": [{
      "hkey": "a6d07c89",
      "slug": "agliana",
      "name": "Agliana",
      "primary": true,
      "skipSearch": false
    }],
    "ronco": [{
      "hkey": "a6d07c89",
      "slug": "agliana",
      "name": "Agliana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e36e2a12": [{
      "hkey": "a6d07c89",
      "slug": "agliana",
      "name": "Agliana",
      "primary": true,
      "skipSearch": false
    }],
    "salceto": [{
      "hkey": "a6d07c89",
      "slug": "agliana",
      "name": "Agliana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ec1f0a3b": [{
      "hkey": "916b156d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "san-michele": [{
      "hkey": "916b156d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "agliana"
    }],
    "9a2a4cb7": [{
      "hkey": "916b156d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "san-niccolo": [{
      "hkey": "916b156d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "agliana"
    }],
    "4fb672d6": [{
      "hkey": "916b156d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "san-piero": [{
      "hkey": "916b156d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "agliana"
    }]
  }
};
exports["default"] = _default;